import { Icon } from '@tkww/orion-web-ds-graphic';

import AnalyticsConstants from '@constants/analytics';
import { useLiteStorefront } from '@hooks/use-lite-storefront';
import { buildAnalyticsEvent } from '@utils/buildAnalyticsEvent';
import React, { type FC } from 'react';
import { Link } from 'react-scroll';
import type { Track } from 'types/analytics';

export interface PhoneProps {
	isFooter?: boolean;
	track: Track;
	vendor: Vendor.Decorated;
	goTo?: string;
}

const Phone: FC<PhoneProps> = (props) => {
	const isLiteStorefront = useLiteStorefront();
	const { isFooter, track, vendor, goTo } = props;

	if (!vendor.phone || isFooter || isLiteStorefront) {
		return null;
	}

	const onClickHandler = () => {
		track(
			buildAnalyticsEvent({
				analyticsEventType: AnalyticsConstants.CALL_VENDOR_INITIATED,
				analyticsProperties: {
					destination: 'phone',
					userDecisionArea: 'Vendor Info',
				},
				vendor,
			}),
		);
	};
	const to = goTo || 'navContact';
	const href = `#${to}`;

	return (
		<Link
			href={href}
			to={to}
			smooth
			offset={-25}
			onClick={onClickHandler}
			title="Go to contact section"
		>
			<Icon
				name="phone"
				size="md"
				data-testid="phone-icon"
				aria-label="Phone"
			/>
		</Link>
	);
};

export default Phone;
